module.exports = __webpack_public_path__ + "img/pure and righteous crow tengu.fa2fb3c0.png";